import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { RouterTestingHarness } from '@angular/router/testing';
import { ConfirmationService, MessageService } from 'primeng/api';
import { MultiSelect, MultiSelectItem } from 'primeng/multiselect';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ActivityCommentService } from 'src/app/shared/services/activity-comment.service';
import { Customer, CustomerService } from 'src/app/shared/services/customer.service';
import { ProductsService } from 'src/app/shared/services/products.service';
import { ProspectsService } from 'src/app/shared/services/prospects.service';
import { SalesService, Users } from 'src/app/shared/services/sales.service';
import { sectorslist, SectorsService } from 'src/app/shared/services/sectors.service';
import { SpinnerServiceService } from 'src/app/shared/services/spinner-service.service';
import { LoggingUser, UserConfigService } from 'src/app/shared/services/user-config.service';
import { ProspectActivity, User } from 'src/app/domain/prospect.model';

@Component({
  selector: 'app-prospect-form',
  templateUrl: './prospect-form.component.html',
  styleUrls: ['./prospect-form.component.scss'],
})
export class ProspectFormComponent implements OnInit, AfterViewInit, AfterViewChecked {
  prospectForm: FormGroup;
  currentMode: 'add' | 'edit' | 'view' = 'add';
  modes = [
    { label: 'Add', value: 'add' },
    { label: 'Edit', value: 'edit' },
    { label: 'View', value: 'view' }
  ];

  // Property to track if the current prospect being edited is a draft
  isEditingDraftProspect: boolean = false;

  newActivities: any[] = [];

  // brandOptions = [
  //   { label: 'SBM Product', value: 'SBM Product' },
  //   { label: 'Managed Service', value: 'Managed Service' },
  //   { label: 'Watheq', value: 'Watheq' },
  //   { label: 'Integration', value: 'Integration' },
  //   { label: 'Data', value: 'Data' }
  // ];

  brandOptions: any[];

  // sectorOptions = [
  //   { label: 'Public', value: 'Public' },
  //   { label: 'Banking', value: 'Banking' }
  // ];

  sectorOptions: sectorslist[] = [];

  // customerOptions = [
  //   { label: 'HRDS', value: 'HRDS' },
  //   { label: 'Inma Bank', value: 'Inma Bank' },
  //   { label: 'BAJ', value: 'BAJ' },
  //   { label: 'ANB', value: 'ANB' },
  //   { label: 'SNB', value: 'SNB' }
  // ];

  customerOptions: Customer[] = [];
  salesOptions: Users[] = [];
  technicalLeadsOptions: Users[] = [];
  opportunityOptions: { opportunityId: number, opportunityName: string, year?: number, status?: string }[] = [];
  selectedOpportunity: any = null;
  lastChangedField: string = ''; // Track which field triggered data reloading

  statusOptions = [
    { label: 'New', value: 'New' },
    { label: 'Contacted', value: 'Contacted' },
    { label: 'Engaged', value: 'Engaged' },
    { label: 'Qualified', value: 'Qualified' },
    // { label: 'InProgress', value: 'InProgress' },
    { label: 'Proposal Submission', value: 'Proposal Submission' },
    { label: 'Proposal sent', value: 'Proposal sent' },
    { label: 'Negotiation', value: 'Negotiation' },
    { label: 'De-Qualified', value: 'De-Qualified' },
    { label: 'Closed as Won', value: 'Closed as Won' },
    { label: 'Closed as Lost', value: 'Closed as Lost' },
    { label: 'Re-engage Later', value: 'Re-engage Later' },
  ];

  currentStatus: any = [{ label: 'New', value: 'New' },
  { label: 'Contacted', value: 'Contacted' },
  { label: 'Engaged', value: 'Engaged' },
  { label: 'Qualified', value: 'Qualified' },
  // { label: 'InProgress', value: 'InProgress' },
  { label: 'Proposal Submission', value: 'Proposal Submission' },
  { label: 'Proposal sent', value: 'Proposal sent' },
  { label: 'Negotiation', value: 'Negotiation' },
  { label: 'Closed as Won', value: 'Closed as Won' }
  ];

  basicStatus = [{ label: 'New', value: 'New' },
  { label: 'Contacted', value: 'Contacted' },
  { label: 'Engaged', value: 'Engaged' },
  { label: 'Qualified', value: 'Qualified' },
  // { label: 'InProgress', value: 'InProgress' },
  { label: 'Proposal Submission', value: 'Proposal Submission' },
  { label: 'Proposal sent', value: 'Proposal sent' },
  { label: 'Negotiation', value: 'Negotiation' },
  { label: 'Closed as Won', value: 'Closed as Won' }
  ];
  currentStatusIndex: any = 0;



  ViewMode: Boolean = false;
  auditHistory: any[] = [];
  activities: any[] = []; // List of activities
  newActivityTitle: string = ''; // Title for new activity
  newActivityDescription: string = ''; // Description for new activity
  newActivityAttendance: number[] = []; // Attachments for new activity
  newActivityAttachment: File | null = null; // Attachment for new activity
  hasCreateOpportunityPermission: boolean = false; // Permission flag for creating opportunities
  newActivityDate: Date = new Date(); // Date for new activity
  newAttachmentBase64: { attachmentName: string; content: string; contentType: string } | null = null; // Store pre-processed attachment
  tempId: any;
  currentUser: LoggingUser;

  // New properties to resolve errors
  loading: boolean = false; // For spinner
  msgs: any[] = []; // For p-messages
  index: number = 0; // For p-tabView activeIndex
  isCollapsed: { [key: string]: boolean } = { prospectDetails: false }; // For collapsible sections

  @ViewChild('attendanceMultiSelect') attendanceMultiSelect: MultiSelect;
  @ViewChild('commentsList') commentsList: ElementRef | undefined;
  @ViewChild('commentsSection') commentsSection: ElementRef | undefined;

  // commentDialog
  commentDialogVisible: boolean = false;
  comments: { userName: string, creationDate: Date, commentText: string }[] = [];
  newComment = { text: '' };
  activeActivityIndex: number = null;

  // Track selected products
  selectedProducts: any[] = [];
  selectedCategory: any = null;
  selectedType: any = null;
  selectedItem: any = null;
  selectedProductId: any = null;

  // Edit activity related properties
  isEditingActivity: boolean = false;
  editingActivityId: number | null = null;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private productService: ProductsService,
    private sectorService: SectorsService,
    private customerService: CustomerService,
    private prospectsService: ProspectsService,
    private salesService: SalesService,
    private router: Router,
    private user: UserConfigService,
    private commentService: ActivityCommentService,
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef,
    private authService: AuthenticationService

  ) {
    this.createForm();

    const navigation = this.router.getCurrentNavigation();
    this.currentMode = navigation?.extras.state?.mode || 'add';
    this.tempId = navigation?.extras.state?.prospectId;

    // Check if draft status is passed directly in the state
    if (this.currentMode === 'edit' && navigation?.extras.state?.draftProspect === true) {
      this.isEditingDraftProspect = true;
    }

    // Add debugging for initialization
    console.log('ProspectFormComponent initialization:', {
      mode: this.currentMode,
      prospectId: this.tempId,
      isDraft: this.isEditingDraftProspect,
      state: navigation?.extras.state
    });

    // Check permission for creating opportunities
    this.checkOpportunityPermissions();
  }

  async ngOnInit() {
    // Set the isEditingDraftProspect flag based on initial mode
    console.log('ngOnInit - Setting initial mode:', this.currentMode);

    // If we're in edit mode, we'll need to wait for the prospect to load
    // to determine if it's a draft, but initialize to false for safety
    this.isEditingDraftProspect = false;

    // Check permissions initially
    this.checkOpportunityPermissions();

    // Subscribe to auth service login completed event to refresh permissions
    this.authService.loginCompleted$.subscribe(() => {
      console.log('Login completed, refreshing permissions');
      this.checkOpportunityPermissions();
    });

    // this.loadBrands();
    // this.loadSectors();
    // this.loadSales();
    // this.loadCustomers();
    // this.loadCurrentUser();
    // this.loadTechnicalLeads();
    // if (this.tempId) {
    //   this.loadProspectById(this.tempId);
    // } else {
    //   this.loadCurrentStatus();
    // }

    SpinnerServiceService.showSpinner();

    this.loadCurrentUser();

    if (this.tempId) {
      this.loadProspectById(this.tempId);
      // Initialize opportunity options array
      this.opportunityOptions = [];
    } else {
      this.loadCurrentStatus();
    }

    await Promise.all([
      this.loadBrands(),
      this.loadSectors(),
      this.loadSales(),
      this.loadCustomers(),
      this.loadTechnicalLeads(),

    ]);




  }

  ngAfterViewChecked() {
    if (this.commentDialogVisible && this.commentsList) {
      this.scrollToBottom();
    }


  } ngAfterViewInit() {
    // Set default tech leads after view initialization
    console.log('ngAfterViewInit: attendanceMultiSelect:', this.attendanceMultiSelect);

    // Wait for both the current user and technical leads options to be available
    if (this.currentUser && this.technicalLeadsOptions.length > 0) {
      this.setDefaultTechLeads();
    }

    // Enhanced dropdown binding for edit mode
    if (this.tempId && this.currentMode === 'edit') {
      // Try to ensure any dropdown bindings are properly reflected after view init
      setTimeout(() => {
        this.ensureProductBinding();

        // Debug opportunity binding
        console.log('AfterViewInit - opportunity binding check:');
        console.log('- selectedOpportunity:', this.selectedOpportunity);
        console.log('- opportunityId form value:', this.prospectForm.get('opportunityId')?.value);
        console.log('- opportunityName form value:', this.prospectForm.get('opportunityName')?.value);

        // If opportunity data exists in the form but not in the dropdown, try to sync it
        if (this.prospectForm.get('opportunityId')?.value && !this.selectedOpportunity) {
          this.selectedOpportunity = {
            opportunityId: this.prospectForm.get('opportunityId')?.value,
            opportunityName: this.prospectForm.get('opportunityName')?.value
          };
          console.log('Synced selectedOpportunity from form values:', this.selectedOpportunity);
        }
      }, 500);
    }
  }


  createForm() {
    this.prospectForm = this.fb.group({
      brandId: ['', Validators.required],
      sectorId: ['', Validators.required],
      customerId: ['', Validators.required],
      title: ['', Validators.required],
      status: ['', Validators.required],
      oddPercent: [{ value: 0, disabled: true }],
      salesId: ['', Validators.required],
      date: ['', Validators.required],
      serviceValue: ['', Validators.required],
      techLeadsIds: ['', Validators.required],
      remarks: [''],
      prospectCreator: [''],
      creationDate: [''],
      countOfActivities: [0],
      opportunityId: [''],
      opportunityName: [''],
      draftProspect: [false], // Add the draftProspect field to the form
    });

  }

  navigateToProspect(): void {
    this.router.navigate(['/prospects']);
  }

  // Method to navigate to leads page with prospect data
  navigateToLeadsPage() {
    const currentProspect = this.prospectForm.value;
    const navigationState = {
      salesId: currentProspect.salesId,
      customerId: currentProspect.customerId,
      // customerName: currentProspect.customer,
      sectorId: currentProspect.sectorId,
      //   sectorName: currentProspect.sector,
      prospectId: this.tempId || null
    };

    // Navigate to leads page with the required data
    this.router.navigateByUrl('/leads', { state: navigationState });
    // console.log('Navigating to leads page with state:', navigationState);
  }

  async loadProspectById(id: number) {
    this.clearTriggeringField();

    this.prospectsService.getProspectById(id).subscribe(
      (prospect) => {
        console.log('Loaded prospect data:', prospect);

        // 1️⃣ Draft prospect detection
        this.isEditingDraftProspect = this.currentMode === 'edit' && !!prospect.draftProspect;
        console.log('Draft prospect detection:', {
          currentMode: this.currentMode,
          isDraft: prospect.draftProspect,
          isEditingDraftProspect: this.isEditingDraftProspect
        });

        // 2️⃣ Format dates
        prospect.date = prospect.date ? new Date(prospect.date) : null;
        prospect.creationDate = prospect.creationDate
          ? new Date(prospect.creationDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: '2-digit' })
          : null;

        // 3️⃣ Handle brands / products
        this.selectedProductId = prospect.brandsId || prospect.brandsIds || [];
        if (prospect.products?.length) {
          this.selectedProducts = prospect.products.map(p => ({
            productId: p.id,
            category: { category: p.category },
            productType: { productType: p.type },
            item: { item: p.item }
          }));
          this.selectedProductId = this.selectedProducts.map(p => p.productId);
        }

        // 4️⃣ Patch form safely
        const patchData = { ...prospect, brandId: this.selectedProductId };
        this.prospectForm.patchValue(patchData);

        // 5️⃣ Ensure sector is loaded
        if (patchData.customerId && this.currentMode !== 'add' && !patchData.sectorId) {
          this.prospectsService.getSectorByCustomerId(patchData.customerId).subscribe({
            next: sector => this.prospectForm.patchValue({ sectorId: sector.id }),
            error: err => console.error('Error fetching sector:', err)
          });
        }

        // 6️⃣ Handle opportunity
        if (prospect.opportunityId && prospect.opportunityName) {
          this.selectedOpportunity = {
            opportunityId: prospect.opportunityId,
            opportunityName: prospect.opportunityName
          };
          this.prospectForm.patchValue({
            opportunityId: prospect.opportunityId,
            opportunityName: prospect.opportunityName
          });
        }

        // 7️⃣ Load opportunities if edit
        if (this.currentMode === 'edit') {
          this.clearTriggeringField();
          this.loadOpportunities();
        }

        // 8️⃣ Process activities & audit history safely
        this.activities = (prospect.prospectActivities || []).map(act => ({
          ...act,
          postedOnTime: new Date(`1970-01-01T${act.postedOnTime}`),
          activityDate: act.activityDate ? new Date(act.activityDate) : null
        }));

        this.auditHistory = (prospect.prospectAudit || []).map(audit => ({
          ...audit,
          actionTime: new Date(`1970-01-01T${audit.actionTime}`),
          actionBy: audit.actionBy || { firstName: '', lastName: '' } // prevent null errors
        }));

        // 9️⃣ Ensure product & sales bindings
        const ensureBindings = () => {
          if (prospect.salesId) this.prospectForm.patchValue({ salesId: prospect.salesId }, { emitEvent: true });
          this.ensureProductBinding();
          this.cdr.detectChanges();
        };
        setTimeout(ensureBindings, 100);
        setTimeout(ensureBindings, 500);
        setTimeout(() => { ensureBindings(); this.debugFormBindings(); }, 1000);

        // 10️⃣ Load current status
        this.loadCurrentStatus();

        // 11️⃣ Hide spinner
        SpinnerServiceService.hideSpinner();
      }
    );
  }


  async loadBrands() {
    await this.productService.getProductsByCategorySBM().subscribe((data) => {
      const sbmItems = [];
      const otherItems = [];

      data.forEach(item => {
        if (item.productCategory?.category === 'SBM' ||
          (item.productType?.productType &&
            typeof item.productType.productType === 'string' &&
            item.productType.productType.includes('SBM'))) {
          sbmItems.push(item);
        } else {
          otherItems.push(item);
        }
      });

      const sortedData = [...sbmItems, ...otherItems];

      console.log('SBM items count:', sbmItems.length);
      console.log('Other items count:', otherItems.length);
      console.log('First few sorted items:',
        sortedData.slice(0, 5).map(item => ({
          category: item.productCategory?.category,
          type: item.productType?.productType
        }))
      );

      this.brandOptions = sortedData.map((brand) => ({
        label: brand.productType?.productType || '' + (brand.productItem?.item || ''),
        value: brand.productId
      }));
    });
  }

  async loadSectors() {
    // await this.sectorService.getsectorsList().toPromise().then(
    //   response => {
    //     this.sectorOptions = response;
    //   },
    // );

    await this.sectorService.retriveSectors().toPromise().then(
      response => {
        this.sectorOptions = response;
        console.log('Loaded sectors:', this.sectorOptions);
      }
    );

  }

  async loadCustomers() {
    await this.customerService.retrieveAllCustomers().toPromise().then(
      response => {
        this.customerOptions = response;
        SpinnerServiceService.hideSpinner();
      }
    );
  }

  async loadSales() {
    await this.salesService.retrievePopularSales().toPromise().then(
      response => {
        this.salesOptions = response.map(user => ({
          ...user,
          fullName: `${user.firstName} ${user.lastName}`
        }));

        console.log("salesOptions", this.salesOptions)
      });
  }
  // async loadTechnicalLeads() {
  //   try {
  //     this.technicalLeadsOptions = await this.salesService.retrieveTechLeads().toPromise();

  //     console.log('Technical Leads Options:', this.technicalLeadsOptions);
  //   } catch (err) {
  //     console.error('Error loading technical leads', err);
  //   }
  // }  

  async loadTechnicalLeads() {
    await this.salesService.retrieveTechLeads().toPromise().then(
      response => {
        this.technicalLeadsOptions = response.map(user => ({
          ...user,
          fullName: `${user.firstName} ${user.lastName}`
        }));
        this.setDefaultTechLeads();
      });
  }


  loadOpportunities() {
    if (this.currentMode === 'edit' &&
      this.prospectForm.get('customerId')?.value &&
      this.prospectForm.get('sectorId')?.value) {
      const customerId = this.prospectForm.get('customerId')?.value;
      const sectorId = this.prospectForm.get('sectorId')?.value;
      const dateValue = this.prospectForm.get('date')?.value;
      const year = dateValue ? new Date(dateValue).getFullYear() : new Date().getFullYear();


      const statusList = [6];

      // Store the field that triggered the reload (for determining reset behavior)
      const triggeringField = this.lastChangedField || '';
      const shouldResetSelection = ['customerId', 'sectorId', 'date'].includes(triggeringField);


      // Save the current selected opportunity before loading new options
      // Use the form values if selectedOpportunity is null (initial load case)
      let currentOpportunityId = this.selectedOpportunity?.opportunityId || this.prospectForm.get('opportunityId')?.value;
      let currentOpportunityName = this.selectedOpportunity?.opportunityName || this.prospectForm.get('opportunityName')?.value;


      // If we have an ID but no name, try to get it from the form
      if (currentOpportunityId && !currentOpportunityName) {
        currentOpportunityName = this.prospectForm.get('opportunityName')?.value;
      }

      this.prospectsService.searchOpportunities(customerId, sectorId, year, statusList)
        .subscribe(
          (opportunities) => {
            // If customer, sector, or date changed, reset the selection
            if (shouldResetSelection) {
              this.selectedOpportunity = null;

              // Clear the form values for opportunity
              this.prospectForm.patchValue({
                opportunityId: null,
                opportunityName: null
              });

              // Enhance opportunities with year and status information if they don't already have it
              this.opportunityOptions = opportunities.map(opp => ({
                ...opp
              }));
              return;
            }

            // Enhance opportunities with year and status information if they don't already have it
            this.opportunityOptions = opportunities;

            // If we have a current opportunity ID and name, check if it exists in options
            if (currentOpportunityId) {
              const opportunityStillExists = this.opportunityOptions.some(
                o => o.opportunityId === currentOpportunityId
              );

              if (!opportunityStillExists && currentOpportunityName) {
                // The opportunity doesn't exist in the loaded options but we have the data
                // Add it to the options so it can be selected
                this.opportunityOptions.push({
                  opportunityId: currentOpportunityId,
                  opportunityName: currentOpportunityName
                });

                // Set the selected opportunity
                this.selectedOpportunity = {
                  opportunityId: currentOpportunityId,
                  opportunityName: currentOpportunityName
                };
              } else if (opportunityStillExists) {
                // The opportunity exists in the options, set it as selected
                this.selectedOpportunity = this.opportunityOptions.find(
                  o => o.opportunityId === currentOpportunityId
                );
              }

            }
          },
          (error) => {
            this.opportunityOptions = [];

            // Even if loading fails, if we have opportunity data and we're not resetting,
            // create an option for it
            if (currentOpportunityId && currentOpportunityName && !shouldResetSelection) {
              this.opportunityOptions = [{
                opportunityId: currentOpportunityId,
                opportunityName: currentOpportunityName
              }];

              this.selectedOpportunity = {
                opportunityId: currentOpportunityId,
                opportunityName: currentOpportunityName
              };
            }
          }
        );
    } else {
      // Reset opportunities if not in edit mode
      this.opportunityOptions = [];
      this.selectedOpportunity = null;
    }
  }

  loadCurrentUser() {
    this.user.getLoggingUser().subscribe(
      (user) => {
        this.currentUser = user;

      }
    );


  }

  setDefaultTechLeads() {

    if (!this.currentUser || !this.currentUser.id) {
      console.warn('Current user or user ID is not available');
      return;
    }

    const defaultTechLeads = this.technicalLeadsOptions
      .filter(lead => lead.userId === this.currentUser.id)
      .map(lead => lead.userId);

    console.log('Default Tech Leads:', defaultTechLeads);

    if (defaultTechLeads.length === 0) {
      console.warn('Current user is not a technical lead');
      return;
    }

    if (this.currentMode === 'edit') {
      this.newActivityAttendance = defaultTechLeads;
      console.log('Default tech leads for edit:', this.newActivityAttendance);
    } else if (this.currentMode === 'add') {
      this.prospectForm.patchValue({
        techLeadsIds: defaultTechLeads
      });
      this.newActivityAttendance = defaultTechLeads;
      console.log('Default tech leads for add (form):', this.prospectForm.get('techLeadsIds').value);
      console.log('Default tech leads for add (activity):', this.newActivityAttendance);
    }

    if (this.attendanceMultiSelect) {
      console.log('Updating p-multiSelect with:', this.newActivityAttendance);
      this.attendanceMultiSelect.updateModel(this.newActivityAttendance);
      this.cdr.detectChanges();
    } else {
      console.warn('attendanceMultiSelect ViewChild is not available');
    }

  }

  loadCurrentStatus() {
    let Status = this.prospectForm.get('status').value ? this.prospectForm.get('status').value : 'New';
    console.log('status', Status);

    this.currentStatus = [...this.basicStatus];

    console.log('currentStatus', this.currentStatus)

    switch (Status) {
      case 'Closed as Lost':
        this.currentStatus.pop();
        this.currentStatus.push({ label: 'Closed as Lost', value: 'Closed as Lost' });
        this.currentStatusIndex = this.currentStatus.findIndex(item => item.label === Status);
        break;

      case 'Re-engage Later':
        this.currentStatus.pop();
        this.currentStatus.push({ label: 'Re-engage Later', value: 'Re-engage Later' });
        this.currentStatusIndex = this.currentStatus.findIndex(item => item.label === Status);
        break;

      case 'De-Qualified':
        this.currentStatus = this.currentStatus.slice(0, 3);
        this.currentStatus.push({ label: 'De-Qualified', value: 'De-Qualified' });
        this.currentStatusIndex = 3;
        break;
      case 'Closed as Won':
        this.currentStatus.pop();
        this.currentStatus.push({ label: 'Closed as Won', value: 'Closed as Won' });
        this.currentStatusIndex = this.currentStatus.findIndex(item => item.label === Status);

        break;
      default:
        console.log('default', Status)
        this.currentStatusIndex = this.currentStatus.findIndex(item => item.label === Status);
        break;
    }



  }


  // loadMockData() {
  //   this.activities = [
  //     {
  //       title: 'Initial Meeting',
  //       description: 'Discussed project requirements with the client.',
  //       date: new Date(),
  //       user: 'John Doe'
  //     },
  //     {
  //       title: 'Proposal Sent',
  //       description: 'Sent the project proposal to the client for review.',
  //       date: new Date(),
  //       user: 'Jane Smith'
  //     }
  //   ];

  //   // Mock audit history data
  //   this.auditHistory = [
  //     {
  //       action: 'Submitted Prospect',
  //       actionType: 'Creation',
  //       user: 'Ahmed Adel',
  //       status: 'New',
  //       dateTime: new Date(),
  //       description: 'Prospect was created and submitted for review.'
  //     }
  //   ];
  // }

  isViewMode(): boolean {
    this.ViewMode = this.currentMode === 'view';
    return this.currentMode === 'view';
  }

  // isDraftProspect(): boolean {
  //   console.log('isDraftProspect called, returning:', this.isEditingDraftProspect);
  //   return this.isEditingDraftProspect;
  // }

  onModeChange(event: any) {
    if (event.value === 'view') {
      this.prospectForm.disable();
    } else {
      this.prospectForm.enable();
      // Keep oddPercent disabled
      this.prospectForm.get('oddPercent')?.disable();
    }
  }

  updateOddPercent(event: any) {
    const statusMap: { [key: string]: number } = {
      'New': 5,
      'Contacted': 25,
      'Engaged': 50,
      'Closed as Won': 100
    };

    this.prospectForm.patchValue({
      oddPercent: statusMap[event.value] || 0
    });
    this.loadCurrentStatus();
  }

  onAttendanceChange(event: any): void {
    this.newActivityAttendance = event.value; // Update the array with the selected values
  }

  // Handle activity date changes
  onActivityDateChange(event: any): void {
    // The p-calendar component will automatically update the newActivityDate model
    console.log('Activity date changed:', this.newActivityDate);
  } onCustomerChange(event: any) {
    // Get the selected customerId
    const customerId = event.value;

    // Show loading state
    SpinnerServiceService.showSpinner();

    if (customerId) {
      // Call the API to get sector based on customerId
      this.prospectsService.getSectorByCustomerId(customerId).subscribe({
        next: (sectorData) => {
          console.log('Sector data loaded:', sectorData);

          // Set the sectorId in the form
          this.prospectForm.patchValue({
            sectorId: sectorData.id
          });

          // Find the sector option with matching id to display the name
          const selectedSector = this.sectorOptions.find(s => s.sectorId === sectorData.id);
          console.log('Selected sector:', selectedSector);

          SpinnerServiceService.hideSpinner();
        },
        error: (error) => {
          console.error('Error loading sector data:', error);
          // Show error message to user
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to load sector information for the selected customer'
          });
          SpinnerServiceService.hideSpinner();
        }
      });
    } else {
      // Customer was cleared, reset the sector
      this.prospectForm.patchValue({
        sectorId: null
      });

      // Hide loading spinner when customer is cleared
      SpinnerServiceService.hideSpinner();
    }

    if (this.currentMode === 'edit') {
      // Set the last changed field to trigger appropriate reset behavior
      this.lastChangedField = 'customerId';
      // Load new opportunities or reset them if customer is cleared
      if (customerId) {
        this.loadOpportunities();
      } else {
        // Reset opportunities when customer is cleared
        this.opportunityOptions = [];
        this.selectedOpportunity = null;
        this.prospectForm.patchValue({
          opportunityId: null,
          opportunityName: null
        });
      }
    }
  } onSectorChange(event: any) {
    if (this.currentMode === 'edit') {
      // Set the last changed field to trigger appropriate reset behavior
      this.lastChangedField = 'sectorId';
      // Load new opportunities
      this.loadOpportunities();
    }
  } onOpportunityChange(event: any) {
    console.log('Opportunity change event:', event);
    console.log('Current selectedOpportunity:', this.selectedOpportunity);

    // Clear the lastChangedField since we're explicitly handling this change
    this.lastChangedField = '';

    if (event) {
      // If event is received directly from dropdown
      this.prospectForm.patchValue({
        opportunityId: event.opportunityId,
        opportunityName: event.opportunityName
      });
    } else if (this.selectedOpportunity) {
      // If no direct event but selectedOpportunity exists (happens sometimes with PrimeNG)
      this.prospectForm.patchValue({
        opportunityId: this.selectedOpportunity.opportunityId,
        opportunityName: this.selectedOpportunity.opportunityName
      });
    } else {
      // Clear the values if nothing is selected
      this.prospectForm.patchValue({
        opportunityId: null,
        opportunityName: null
      });
    }

    console.log('Form values after opportunity change:',
      this.prospectForm.get('opportunityId')?.value,
      this.prospectForm.get('opportunityName')?.value);
  }
  // Handle date changes to update opportunities based on the new year
  onDateChange(event: any) {
    if (this.currentMode === 'edit') {
      // Set the last changed field to trigger appropriate reset behavior
      this.lastChangedField = 'date';
      // Load new opportunities
      this.loadOpportunities();
    }
  }

  // Handle file selection and process Base64
  onFileSelect(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const maxSize = 10 * 1024 * 1024; // 50 MB
      if (file.size > maxSize) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'File size exceeds 10 MB limit'
        });
        input.value = '';
        this.newActivityAttachment = null;
        this.newAttachmentBase64 = null;
        return;
      }
      this.newActivityAttachment = file;

      const reader = new FileReader();
      reader.onload = () => {
        const base64String = (reader.result as string).split(',')[1]; // Remove data URL prefix
        this.newAttachmentBase64 = {
          attachmentName: file.name,
          content: base64String,
          contentType: file.type
        };
      };
      reader.onerror = () => {
        console.error('Error reading file');
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to process attachment'
        });
        input.value = '';
        this.newActivityAttachment = null;
        this.newAttachmentBase64 = null;
      };
      reader.readAsDataURL(file);
    } else {
      this.newActivityAttachment = null;
      this.newAttachmentBase64 = null;
    }
  }

  clearFileInput(): void {
    this.newActivityAttachment = null;
    this.newAttachmentBase64 = null;
    const fileInput = document.getElementById('activityAttachment') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  clearActivityAttendance() {
    this.newActivityAttendance = [];
    if (this.attendanceMultiSelect) {
      this.newActivityAttendance = this.technicalLeadsOptions.filter(lead => lead.userId === this.currentUser.id).map(lead => lead.userId);

      this.attendanceMultiSelect.writeValue(this.newActivityAttendance);
    }
  }

  addActivity() {
    if (this.newActivityTitle?.trim() && this.newActivityDescription?.trim()) {
      let newAttendance = this.technicalLeadsOptions.filter(
        lead => this.newActivityAttendance.includes(lead.userId)
      );

      // Prepare AppliancesAttachmentDto
      let applianceAttachment: any = null;
      if (this.newAttachmentBase64) {
        applianceAttachment = {
          attachmentName: this.newAttachmentBase64.attachmentName,
          content: this.newAttachmentBase64.content, // Base64 string
          contentType: this.newAttachmentBase64.contentType,
          created: new Date().toISOString(), // ISO string for LocalDateTime
          creatorId: this.currentUser.id || -1 // Adjust based on your user model
          // linkedEntityId and linkedType can be set in the backend if needed
        };
      }

      console.log('applianceAttachment', applianceAttachment);

      // Check if we're editing or adding a new activity
      if (this.isEditingActivity && this.editingActivityId) {
        // Edit existing activity
        const editData = {
          title: this.newActivityTitle,
          description: this.newActivityDescription,
          attendancesIds: this.newActivityAttendance,
          activityDate: this.newActivityDate
        };

        SpinnerServiceService.showSpinner();
        this.prospectsService.editProspectActivity(this.editingActivityId, editData).subscribe(
          (response) => {
            console.log('Activity updated successfully:', response);

            // Update the activity in the list
            const index = this.activities.findIndex(a => a.id === this.editingActivityId);
            if (index !== -1) {
              // Preserve properties that aren't changed by the edit
              const updatedActivity = {
                ...this.activities[index],
                title: response.title || this.newActivityTitle,
                description: response.description || this.newActivityDescription,
                activityDate: response.activityDate || this.newActivityDate,
                attendances: this.technicalLeadsOptions
                  .filter(lead => this.newActivityAttendance.includes(lead.userId))
                  .map(lead => ({
                    id: lead.userId,
                    firstName: lead.firstName,
                    lastName: lead.lastName,
                    userId: lead.userId,
                    email: lead.email
                  }))
              };

              this.activities[index] = updatedActivity;
            }

            // Reset the form
            this.resetActivityForm();

            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Activity updated successfully'
            });

            SpinnerServiceService.hideSpinner();
          },
          (error) => {
            console.error('Error updating activity:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to update activity'
            });
            SpinnerServiceService.hideSpinner();
          }
        );
      } else {
        // Add new activity
        let activity = {
          prospectId: null,
          title: this.newActivityTitle,
          description: this.newActivityDescription,
          attendancesIds: this.newActivityAttendance,
          applianceAttachment: applianceAttachment,
          activityDate: this.newActivityDate
        };

        if (this.currentMode === 'edit') {
          activity.prospectId = this.tempId;
          console.log('activity', activity);
          SpinnerServiceService.showSpinner();
          this.prospectsService.addActivity(activity).subscribe(
            (response) => {
              console.log('Activity added successfully:', response);
              response.postedOnTime = new Date(`1970-01-01T${response.postedOnTime}`);
              // Format activityDate if it exists in the response
              if (response.activityDate) {
                response.activityDate = new Date(response.activityDate);
              }
              this.activities.unshift(response);
              SpinnerServiceService.hideSpinner();
            },
            (error) => {
              SpinnerServiceService.hideSpinner();
              console.error('Error adding activity:', error);
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to add activity'
              });
            }
          );
        } else {
          this.newActivities.push(activity);
          this.activities.unshift({
            title: this.newActivityTitle,
            description: this.newActivityDescription,
            postedOnTime: new Date(),
            postedOnDate: new Date(),
            activityDate: this.newActivityDate,
            status: this.prospectForm.get('status').value ? this.prospectForm.get('status').value : 'New',
            createdBy: {
              firstName: this.currentUser.firstName,
              lastName: this.currentUser.lastName
            },
            attendances: newAttendance,
            applianceAttachment: applianceAttachment,
          });
        }

        // Clear the form
        this.newActivityTitle = '';
        this.newActivityDescription = '';
        this.clearActivityAttendance();
        this.clearFileInput();

        // Show success message
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Activity added successfully'
        });
      }
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please fill in all fields'
      });
    }
  }


  downloadAttachment(attachment: { attachmentName: string; content: string; contentType: string }) {
    // Convert Base64 string to a Blob
    const byteCharacters = atob(attachment.content);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: attachment.contentType });

    // Create a link and trigger the download
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = attachment.attachmentName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }


  // Add this method to handle navigation
  // openPrevious(tabIndex: number) {
  //  this.currentStatusIndex= tabIndex;
  //   this.index = this.currentStatusIndex;
  //   console.log('currentStatusIndex', this.currentStatusIndex);
  //   console.log('index', this.index);
  // }

  // openNext(tabIndex: number) {
  //   this.currentStatusIndex = tabIndex;
  //   this.index = this.currentStatusIndex;
  //   console.log('currentStatusIndex', this.currentStatusIndex);
  //   console.log('index', this.index);
  // }

  // Navigate to the next step
  navigateNext() {
    if (this.prospectForm.valid) {
      this.index++;
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please fill in all required fields'
      });
    }
  }

  // Navigate to the previous step
  navigatePrev() {
    if (this.index > 0) { // Ensure we don't go before the first step
      this.index--;
    }
  }

  save(isDraft: boolean = false) {
    if (this.prospectForm.valid) {
      const formData = this.prospectForm.getRawValue();
      // Set the draftProspect flag based on the isDraft parameter
      formData.draftProspect = isDraft;

      // Save opportunity information if one is selected
      if (this.selectedOpportunity && this.currentMode === 'edit') {
        formData.opportunityId = this.selectedOpportunity.opportunityId;
        formData.opportunityName = this.selectedOpportunity.opportunityName;
      }

      // Copy the selected brand IDs from brandId to brandsId and remove brandId
      if (formData.brandId) {
        // If brandId is not an array (e.g., single selection mode), convert it to an array
        if (!Array.isArray(formData.brandId)) {
          formData.brandsId = [formData.brandId];
        } else {
          // Copy the array to ensure no reference issues using the correct field name expected by backend
          formData.brandsId = [...formData.brandId];
        }

        console.log('Set brandsId from brandId:', formData.brandsId);

        // Delete brandId from the form data to avoid sending both fields
        delete formData.brandId;

        // Also remove brandsIds if it exists to ensure we're only sending the correct field
        if (formData.brandsIds) {
          delete formData.brandsIds;
        }
      }

      formData.prospectActivities = this.newActivities;
      formData.productIds = this.selectedProducts.map(product => product.productId);
      console.log('formData (with brandsId, without brandId or brandsIds)', formData);
      if (this.currentMode === 'add') {
        // Set both id and prospectId to 0 for a new prospect
        formData.id = 0;
        formData.prospectId = 0;

        this.prospectsService.addProspect(formData).subscribe(
          (response) => {
            console.log('Prospect saved successfully:', formData.draftProspect ? 'as draft' : 'as final');
            this.prospectForm.reset();
            this.currentMode = 'add';

            // Show appropriate success message based on the action
            let successMessage = '';
            if (formData.draftProspect) {
              successMessage = 'Prospect saved as draft successfully';
            } else if (this.isEditingDraftProspect) {
              successMessage = 'Draft prospect published successfully';
            } else {
              successMessage = 'Prospect saved successfully';
            }

            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: successMessage
            });
            this.navigateToProspect();
            SpinnerServiceService.hideSpinner();

          });
      }


      if (this.currentMode === 'edit' || this.currentMode === 'view') {
        // Ensure the prospectId is set explicitly as required by the backend
        formData.prospectId = this.tempId;

        // Set id too for any other potential uses
        formData.id = this.tempId;

        console.log('formData update with explicit prospectId:', formData);
        this.prospectsService.updateProspect(formData, this.tempId).subscribe(
          (response) => {
            console.log('Prospect updated successfully:');
            this.prospectForm.reset();
            this.currentMode = 'add';

            // Show appropriate success message based on the action for edit mode
            let successMessage = '';
            if (formData.draftProspect) {
              successMessage = 'Draft prospect updated successfully';
            } else if (this.isEditingDraftProspect) {
              successMessage = 'Draft prospect published successfully';
            } else {
              successMessage = 'Prospect updated successfully';
            }

            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: successMessage
            });
            this.navigateToProspect();
            SpinnerServiceService.hideSpinner();
          });
      }


    } else {
      SpinnerServiceService.hideSpinner();
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please fill in all required fields'
      });


    }


  }

  cancel() {
    this.prospectForm.reset();
    this.currentMode = 'add';
  }

  // New methods to resolve errors
  // Helper method to get a list of invalid field names
  getInvalidFields(): string[] {
    const invalidFields: string[] = [];
    const controls = this.prospectForm.controls;

    // Map of control names to user-friendly field names
    const fieldNames: { [key: string]: string } = {
      'brandId': 'Brands',
      'sectorId': 'Sector',
      'customerId': 'Customer',
      'title': 'Title',
      'status': 'Status',
      'salesId': 'Sales',
      'date': 'Date',
      'serviceValue': 'Service Value',
      'techLeadsIds': 'Technical Leads'
    };

    // Check each form control
    Object.keys(controls).forEach(key => {
      const control = controls[key];
      if (control.invalid && (control.dirty || control.touched)) {
        if (fieldNames[key]) {
          invalidFields.push(fieldNames[key]);
        } else {
          invalidFields.push(key); // Use the control name if no friendly name is defined
        }
      }
    });

    return invalidFields;
  }

  onSaveDraft(event: Event) {
    event.preventDefault();
    // Check if there is at least one activity
    if (!this.activities || this.activities.length === 0) {
      this.confirmationService.confirm({
        message: 'You must add at least one activity before saving.',
        header: 'Error',
        icon: 'pi pi-exclamation-triangle',
        acceptVisible: false, // hide "Yes"
        rejectVisible: true,  // show "Ok" button only
        rejectLabel: 'Ok',
        reject: () => {
          console.log('User acknowledged error');
        }
      });
      return; // Stop further execution
    }

    SpinnerServiceService.showSpinner();

    // Mark all fields as touched to trigger validation messages
    Object.values(this.prospectForm.controls).forEach(control => {
      control.markAsTouched();
    });

    if (this.prospectForm.valid) {
      this.save(true); // Pass true to indicate this is a draft
    } else {
      SpinnerServiceService.hideSpinner();

      // Create a specific error message
      const invalidFields = this.getInvalidFields();
      let errorDetail: string;
      if (invalidFields.length > 0) {
        errorDetail = `Please fill in the following required fields to save as draft: ${invalidFields.join(', ')}`;
      } else {
        errorDetail = 'Please check form for errors before saving as draft';
      }

      this.messageService.add({
        severity: 'error',
        summary: 'Validation Error',
        detail: errorDetail
      });

      this.scrollToFirstInvalidField();
    }
  }

  onSubmit(event: Event) {
    event.preventDefault();

    if (!this.activities || this.activities.length === 0) {
      this.confirmationService.confirm({
        message: 'You must add at least one activity before submitting.',
        header: 'Error',
        icon: 'pi pi-exclamation-triangle',
        acceptVisible: false,
        rejectVisible: true,
        rejectLabel: 'Ok'
      });
      return; // Stop further execution
    }

    SpinnerServiceService.showSpinner();

    // Mark all fields as touched to trigger validation messages
    Object.values(this.prospectForm.controls).forEach(control => {
      control.markAsTouched();
    });

    if (this.prospectForm.valid) {
      this.save(false); // Pass false to indicate this is not a draft
    } else {
      SpinnerServiceService.hideSpinner();

      // Get list of invalid fields
      const invalidFields = this.getInvalidFields();

      // Create a specific error message
      let errorDetail: string;
      if (invalidFields.length > 0) {
        errorDetail = `Please fill in the following required fields: ${invalidFields.join(', ')}`;
      } else {
        errorDetail = 'Please check form for errors';
      }

      this.messageService.add({
        severity: 'error',
        summary: 'Validation Error',
        detail: errorDetail
      });

      // Scroll to the first invalid field
      this.scrollToFirstInvalidField();
    }
  }

  // Helper method to scroll to the first invalid field
  scrollToFirstInvalidField() {
    setTimeout(() => {
      const invalidControl = Object.keys(this.prospectForm.controls)
        .find(key => this.prospectForm.controls[key].invalid);

      if (invalidControl) {
        const element = document.querySelector(`[formcontrolname="${invalidControl}"]`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }, 100);
  }

  onTabChange(event: any) {
    this.index = event.index;
  }

  toggleCollapse(section: string) {
    this.isCollapsed[section] = !this.isCollapsed[section];
  }

  // Check if user has permission to create opportunities
  // Check if user has permission to create opportunities
  canCreateOpportunity(): boolean {
    return this.hasCreateOpportunityPermission;
  }

  // Check and cache permission status
  checkOpportunityPermissions(): void {
    const cadenceRole = this.authService.getCadenceRole();
    this.hasCreateOpportunityPermission = cadenceRole &&
      (cadenceRole.cadenceMenu === true || cadenceRole.newOpportunityManagement === true);
    console.log('Opportunity creation permission:', this.hasCreateOpportunityPermission);
  }


  // Scroll to the bottom of the comments section
  private scrollToBottom() {
    if (this.commentsSection) {
      const nativeElement = this.commentsSection.nativeElement;
      console.log('Scrolling to bottom. scrollHeight:', nativeElement.scrollHeight, 'scrollTop:', nativeElement.scrollTop);
      nativeElement.scrollTop = nativeElement.scrollHeight;
    } else {
      console.warn('commentsSection is undefined');
    }
  }

  // Alternative: Scroll to the last comment using scrollIntoView
  // private scrollToLastComment() {
  //   if (this.commentsList && this.comments.length > 0) {
  //       const listItems = this.commentsList.nativeElement.querySelectorAll('li');
  //       const lastItem = listItems[listItems.length - 1];
  //       if (lastItem) {
  //           lastItem.scrollIntoView({ behavior: 'smooth', block: 'end' });
  //       }
  //   } else {
  //       console.warn('commentsList is undefined or no comments');
  //   }
  // }

  openComentDialog(id: number) {
    this.commentDialogVisible = true;
    this.activeActivityIndex = id;
    console.log('activeActivityIndex', this.activeActivityIndex);

    SpinnerServiceService.showSpinner();
    this.commentService.getActivityComments(id).subscribe(
      (response) => {
        console.log('comments', response);
        this.comments = response

        this.cdr.detectChanges(); // Ensure DOM updates before scrolling


        SpinnerServiceService.hideSpinner();
      }, (error) => {
        console.error('Error fetching comments:', error);
        SpinnerServiceService.hideSpinner();
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load comments'
        });
      }
    );
  }


  addComment() {
    if (this.newComment.text) {

      // const now = new Date();
      // const currentDate = now.toLocaleDateString('en-US', {
      //   weekday: 'short', // e.g., "Sun"
      //   day: '2-digit', // e.g., "04"
      //   month: '2-digit', // e.g., "04"
      //   year: 'numeric' // e.g., "2025"
      // }).replace(/(\d+)\/(\d+)\/(\d+)/, '$2/$1/$3'); // Format to "04/27/2025"

      // const currentTime = now.toLocaleTimeString('en-US', {
      //   hour: '2-digit',
      //   minute: '2-digit',
      //   hour12: true // e.g., "04:13 PM"
      // });

      // const formattedDateTime = `${currentDate.split(',')[0]}, ${currentDate.split(',')[1]}, ${currentTime}`; // e.g., "Sun, 04/27/2025, 04:13 PM"

      this.comments.push({
        userName: this.currentUser.firstName + ' ' + this.currentUser.lastName,
        creationDate: new Date(),
        commentText: this.newComment.text
      });

      const comment = {
        activityId: this.activeActivityIndex,
        comment: this.newComment.text,
        userId: this.currentUser.id,
        creationDate: new Date(),

      };

      console.log('comment', comment);

      this.commentService.saveActivityComment(comment).subscribe(
        (response) => {
          console.log('Comment saved successfully:', response);

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Comment added successfully'
          });

          this.activities = this.activities.map(activity => {
            if (activity.id === this.activeActivityIndex) {
              activity.totalComments += 1;
            }
            return activity;
          });


        },
        (error) => {
          console.error('Error saving comment:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to add comment'
          });
        }
      );



      this.newComment = { text: '' };
    }
  }

  deleteProduct(product: any) {
    // Remove from selected products
    this.selectedProducts = this.selectedProducts.filter(p => p.productId !== product.productId);

    // Clear selection in tree component since we deleted it
    this.selectedCategory = null;
    this.selectedType = null;
    this.selectedItem = null;
    this.selectedProductId = null;
  } handleSelectionChanged(selection: any) {
    console.log('Product selection changed:', selection);

    if (Array.isArray(selection) && selection.length > 0) {
      // Extract product IDs from the selection
      const productIds = selection.map(item => item.productId).filter(id => id != null);

      // Update the brandId field - the form only has brandId, brandsId will be updated during save
      this.prospectForm.patchValue({
        brandId: productIds
      });

      // Also update the selectedProductId to maintain consistency
      this.selectedProductId = productIds;

      console.log('Updated form values:', {
        brandId: this.prospectForm.get('brandId').value
      });

      this.selectedProducts = selection;
    } else {
      this.clearProductSelection();
      // Clear the brandId
      this.prospectForm.patchValue({
        brandId: null
      });
    }
  }
  // Method to ensure product data is correctly bound when editing
  ensureProductBinding() {
    if (this.selectedProductId && Array.isArray(this.selectedProductId) && this.selectedProductId.length > 0) {
      console.log('Ensuring product binding for IDs:', this.selectedProductId);

      // Notify the form control that brandId value has changed
      this.prospectForm.patchValue({ brandId: this.selectedProductId }, { emitEvent: true });

      // Force change detection for the component
      this.cdr.detectChanges();

      // Mark form control as touched to trigger validation
      const brandControl = this.prospectForm.get('brandId');
      brandControl.markAsTouched();

      // Log the current state for debugging
      console.log('After binding - brandId value:', brandControl.value);
      console.log('After binding - selectedProductId:', this.selectedProductId);

      // After a short delay, re-validate the binding
      setTimeout(() => {
        if (!this.areArraysEqual(brandControl.value, this.selectedProductId)) {
          console.log('Binding mismatch detected, re-patching...');
          this.prospectForm.patchValue({ brandId: this.selectedProductId }, { emitEvent: true });
          this.cdr.detectChanges();
        }
      }, 100);
    }
  }
  // Helper method to compare arrays (for ensuring value equality)
  private areArraysEqual(arr1: any[], arr2: any[]): boolean {
    if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false;
    if (arr1.length !== arr2.length) return false;

    // Compare each element
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }
    return true;
  }

  // Helper method to debug form and dropdown bindings
  private debugFormBindings(): void {
    // Log form values
    const formValues = {
      brandId: this.prospectForm.get('brandId')?.value,
      salesId: this.prospectForm.get('salesId')?.value,
      opportunityId: this.prospectForm.get('opportunityId')?.value,
      selectedOpportunity: this.selectedOpportunity
    };

    console.log('Form bindings:', formValues);
    console.log('Selected product IDs:', this.selectedProductId);

    // Check if there's a sales option matching the current salesId
    const salesId = formValues.salesId;
    if (salesId && this.salesOptions?.length > 0) {
      const matchingSalesOption = this.salesOptions.find(option => option.userId === salesId);
      console.log('Matching sales option:', matchingSalesOption ?
        `${matchingSalesOption.firstName} ${matchingSalesOption.lastName}` : 'None found');
    }

    // Check if brands are properly bound
    const brandIds = formValues.brandId;
    if (brandIds && Array.isArray(brandIds)) {
      console.log('Brand IDs in form:', brandIds);
      console.log('Brand IDs match selectedProductId:',
        this.areArraysEqual(brandIds, this.selectedProductId as any[]));
    }
  }

  /**
   * Resets the lastChangedField to ensure subsequent operations don't trigger resets
   */
  clearTriggeringField() {
    this.lastChangedField = '';
  }

  private clearProductSelection() {
    this.selectedProducts = [];
    this.selectedCategory = null;
    this.selectedType = null;
    this.selectedItem = null;
    this.selectedProductId = null;
  }
  getKind(): string {
    return 'swg';
  }

  /**
   * Checks if the current user can delete an activity
   * Only the user who created the activity can delete it
   */
  canDeleteActivity(activity: ProspectActivity): boolean {
    // Compare the activity creator's email with the current user's email
    if (!activity || !activity.createdBy || !this.currentUser) {
      return false;
    }

    return activity.createdBy.email === this.currentUser.email;
  }

  /**
   * Deletes a prospect activity
   * @param activityId The ID of the activity to delete
   */
  deleteActivity(activityId: number): void {
    if (!activityId) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Activity ID is required'
      });
      return;
    }

    // No need for extra confirmation dialog here, as it's already handled elsewhere
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this activity?',
      header: 'Confirm Deletion',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.loading = true;
        this.prospectsService.deleteProspectActivity(activityId).subscribe(
          () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Activity deleted successfully'
            });

            // Remove the deleted activity from the local array
            this.activities = this.activities.filter(a => a.id !== activityId);

            // Update the count of activities
            const prospectForm = this.prospectForm.value;
            if (prospectForm && prospectForm.id) {
              this.prospectForm.patchValue({
                countOfActivities: this.activities.length
              });
            }

            this.loading = false;
          },
          error => {
            console.error('Error deleting activity:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to delete activity'
            });
            this.loading = false;
          }
        );
      }
    });
  }

  // Helper method to reset activity form fields after add/edit
  resetActivityForm() {
    this.newActivityTitle = '';
    this.newActivityDescription = '';
    this.newActivityAttachment = null;
    this.newAttachmentBase64 = null;
    this.newActivityDate = null; // Reset to null as it's optional
    this.isEditingActivity = false;
    this.editingActivityId = null;
    // Reset attendance to current user only
    this.clearActivityAttendance();
  }

  // Method to initiate editing of an activity
  startEditActivity(activity: any) {
    this.isEditingActivity = true;
    this.editingActivityId = activity.id;
    this.newActivityTitle = activity.title;
    this.newActivityDescription = activity.description;
    this.newActivityDate = activity.activityDate ? new Date(activity.activityDate) : null;

    // Clear any attachment data since we don't want to modify attachments when editing
    this.newActivityAttachment = null;
    this.newAttachmentBase64 = null;
    const fileInput = document.getElementById('activityAttachment') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }

    // Set attendance IDs
    if (activity.attendances && Array.isArray(activity.attendances)) {
      // Map attendances to their IDs directly (since userId is the key field)
      this.newActivityAttendance = activity.attendances.map(att => att.id || att.userId);
      console.log('Setting attendance IDs:', this.newActivityAttendance);
      if (this.attendanceMultiSelect) {
        this.attendanceMultiSelect.writeValue(this.newActivityAttendance);
      }
    }

    // Scroll to the add activity form
    setTimeout(() => {
      const addActivityElement = document.getElementById('addActivity');
      if (addActivityElement) {
        addActivityElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  }

  // Method to cancel editing
  cancelEditActivity() {
    this.resetActivityForm();
  }

  canEditActivity(activity: any): boolean {
    // Allow editing only if the user is the creator of the activity
    return this.currentUser && activity.createdBy &&
      this.currentUser.id === activity.createdBy.id;
  }
}
